<template>
  <div>
    <LayoutContainer>
      <div class="page" v-if="state.error && !state.isLoading">
        <div class="page-content">
          <EmptyMessage>
            <span slot="icon">
              <img src="@/assets/image/lighthouse.png" />
            </span>
            <h1 slot="title" class="title">ไม่พบ VideoId '{{videoId}}' :(</h1>
            <p>ลองตรวจสอบ Video ID อีกครั้ง</p>
          </EmptyMessage>
        </div>
      </div>
    </LayoutContainer>
    <VideoDetail v-if="!state.error && !state.isLoading" />
  </div>
</template>

<script>
import { loadVideoDetail } from './api';
import generateLink from '@/utils/generateLink';
import EmptyMessage from '@/components/EmptyMessage.vue';
import LayoutContainer from '@/layout/LayoutContainer.vue';
import VideoDetail from '@/video/VideoDetail.vue';

export default {
  mixins: [generateLink],
  data() {
    return {
      state: {
        error: null,
        isLoading: false,
      },
    };
  },
  components: {
    LayoutContainer,
    EmptyMessage,
    VideoDetail,
  },
  watch: {
    '$route.query': {
      handler() {
        const filter = this.generateQuery(this.$route.query);
        this.load(filter);
      },
    },
  },
  computed: {
    videoId() {
      return this.$route.params.videoId;
    },
  },
  created() {
    const filter = this.generateQuery(this.$route.query);
    this.load(filter);
  },
  methods: {
    async load(filter) {
      this.state.isLoading = true;
      try {
        await loadVideoDetail(this.videoId, filter);
        this.state.isLoading = false;
      } catch (error) {
        // this.state.error = error;
        this.state.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import '@/assets/scss/themes/components/page.scss';
</style>
